/**
 * Куда уводит отказ `email_not_verified`.
 *
 * Отдельный модуль на одну константу — по той же причине, по какой `LEGAL_ACCEPT_PATH` живёт в
 * `features/legal/gate`: путь нужен и транспортному обработчику в `App`, и самому экрану, и его
 * тестам, а импортировать экран ради строки значило бы тянуть в стартовый бандл всю страницу
 * подтверждения.
 */
export const CONFIRM_EMAIL_PATH = '/profile/email';
